import caseStudyImg1 from '../assets/images/case-study/case-study-img1.webp';
import caseStudyImg2 from '../assets/images/case-study/case-study-img2.webp';
import caseStudyImg3 from '../assets/images/case-study/case-study-img3.webp';
import caseStudyImg4 from '../assets/images/case-study/case-study-img4.webp';
import caseStudyImg5 from '../assets/images/case-study/case-study-img5.webp';
import caseStudyImg6 from '../assets/images/case-study/case-study-img6.webp';
import caseStudyImg7 from '../assets/images/case-study/case-study-img7.webp';

const CaseStudyList = [
  {
    id: 1,
    imgsrc: caseStudyImg1,
    title: 'Gozzby',
    category: 'Music',
    description:
      'If success is a process with a number of defined steps, then it is just like any other process.',
    client: 'Developer',
    categories: 'It Company',
    budgets: '$250.000',
    location: 'New York, USA',
    url: 'http://www.exampleproject.com',
  },
  {
    id: 2,
    imgsrc: caseStudyImg2,
    title: 'Educatgenix',
    category: 'Education',
    description: 'We all carry a lot of baggage, thanks to our upbringing...',
    client: 'Developer',
    categories: 'It Company',
    budgets: '$250.000',
    location: 'New York, USA',
    url: 'http://www.exampleproject.com',
  },
  {
    id: 3,
    imgsrc: caseStudyImg3,
    title: 'Petfluent',
    category: 'Pet Care',
    description:
      'You will drift aimlessly until you arrive back at the original dock',
    client: 'Developer',
    categories: 'It Company',
    budgets: '$250.000',
    location: 'New York, USA',
    url: 'http://www.exampleproject.com',
  },
  {
    id: 4,
    imgsrc: caseStudyImg4,
    title: 'Financeoont',
    category: 'Finance',
    description:
      'It is truly amazing the damage that we, as parents, can inflict on our children...',
    client: 'Developer',
    categories: 'It Company',
    budgets: '$250.000',
    location: 'New York, USA',
    url: 'http://www.exampleproject.com',
  },
  {
    id: 5,
    imgsrc: caseStudyImg5,
    title: 'Mobifluent',
    category: 'Mobile',
    description: 'Most people believe that success is difficult.',
    client: 'Developer',
    categories: 'It Company',
    budgets: '$250.000',
    location: 'New York, USA',
    url: 'http://www.exampleproject.com',
  },
  {
    id: 6,
    imgsrc: caseStudyImg6,
    title: 'Dentzoid',
    category: 'Dental',
    description:
      'Commitment – understanding the price and having the willingness to pay that price.',
    client: 'Developer',
    categories: 'It Company',
    budgets: '$250.000',
    location: 'New York, USA',
    url: 'http://www.exampleproject.com',
  },
  {
    id: 7,
    imgsrc: caseStudyImg7,
    title: 'Foodocity',
    category: 'Food',
    description:
      'Without clarity, you send a very garbled message out to the Universe.',
    client: 'Developer',
    categories: 'It Company',
    budgets: '$250.000',
    location: 'New York, USA',
    url: 'http://www.exampleproject.com',
  },
];

export default CaseStudyList;
